module.exports = __webpack_public_path__ + "img/icon-load.8dc66536.svg";